import React, { useEffect } from "react";
import Icon1 from "../../images/svg-4.svg";
import Icon2 from "../../images/svg-5.svg";
import Icon3 from "../../images/svg-6.svg";
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
} from "./ServicesElements";
import Aos from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const Services = ({ isRTL }) => {
  const { t } = useTranslation();

  useEffect(() => {
    Aos.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);
  return (
    <ServicesContainer id="services" className={isRTL ? "arabe" : ""}>
      <ServicesH1>
        <span>{t("service.title")}</span> {t("service.title1")}
      </ServicesH1>
      <ServicesWrapper>
        <ServicesCard data-aos="fade-up">
          <ServicesIcon src={Icon1} />
          <ServicesH2>{t("services.serviceTitle1")}</ServicesH2>
          <ServicesP>{t("services.description1")}</ServicesP>
        </ServicesCard>

        <ServicesCard data-aos="fade-up" data-aos-delay="100">
          <ServicesIcon src={Icon2} />
          <ServicesH2>{t("services.serviceTitle2")}</ServicesH2>
          <ServicesP>{t("services.description2")}</ServicesP>
        </ServicesCard>

        <ServicesCard data-aos="fade-up" data-aos-delay="200">
          <ServicesIcon src={Icon3} />
          <ServicesH2>{t("services.serviceTitle3")}</ServicesH2>
          <ServicesP>{t("services.description3")}</ServicesP>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};
Services.propTypes = {
  isRTL: PropTypes.bool,
};
export default Services;
